export default __webpack_public_path__ + "static/media/banner1.1687efa2.png";